import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";

export function LinkAsButton({
  to,
  href,
  children,
  ...props
}: React.ComponentProps<typeof Button> & {
  to?: string;
  href?: string;
}) {
  const linkTo = to || href || "/";
  return (
    <Button asChild {...props}>
      <Link to={linkTo}>{children}</Link>
    </Button>
  );
}
